import React, { useEffect, useState } from "react";
import {
  INavigator,
  MenuLateral,
} from "../../../../Components/MenuLateral/Index";
import { Panel } from "../../../../Components/Panel";
import { Container, Img } from "./syles";
import LogoSinsoft from "../../../../Assets/Sinsoft_Logo.png";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import { useNavigate, useParams } from "react-router";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { app_base_url } from "../../../../Utils/baseUrl";
export function Inicio() {
  const { prefeituraIsLogged, prefeitura } = usePrefeitura();
  const { cartorio, cartorioIsLogged } = useCartorio();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  const { funcionarioCartorioIsLogged } = useFuncionarioCartorio();
  const { destino } = useParams();
  const [loadig, setLoading] = useState(false);
  const navigate = useNavigate();

  async function execute() {
    if (
      destino &&
      (funcionarioCartorioIsLogged ||
        funcionarioPrefeituraIsLogged ||
        cartorioIsLogged ||
        prefeituraIsLogged)
    ) {
      //window.alert(`${destino.replaceAll("_", "/")}`);
      if (destino != undefined) {
        setLoading(true);
        await new Promise((r) => setTimeout(r, 1000));
       
        // if (
        //   window.location.href.indexOf(`${app_base_url}/inicio`) == -1 
         
        // ) {
        //  // navigate(`${app_base_url}/inicio`);
          navigate(`${destino.replaceAll("_", "/")}`);
        // } else {
          
        //   navigate(`${app_base_url}/inicio`);
        // }
      }
    }
  }

  useEffect(() => {
    //window.alert(window.location.pathname.substring(0,23));
 
    if (
      destino != undefined &&
      window.location.pathname.substring(0, 23) == "/itbi/redirecionamento/"
    ){
      execute();
    }else{
      navigate(`${app_base_url}/inicio`);
    }
  }, [
    funcionarioCartorioIsLogged,
    funcionarioPrefeituraIsLogged,
    cartorioIsLogged,
    prefeituraIsLogged,
  ]);

  useEffect(() => {
    if (window.location.href.indexOf(`${app_base_url}/inicio`) != -1)
      setLoading(false);
  }, [window.location.href]);

  return (
    <Container>
      {loadig ? (
        ""
      ) : (
        <MenuLateral
          titulo={
            prefeituraIsLogged || funcionarioPrefeituraIsLogged
              ? prefeitura.NOME
              : cartorio.NOME
          }
        />
      )}

      <Panel
        children={
          <Img
            onClick={() => {
              window.open("http://www.sinsoft.com.br/");
            }}
            src={LogoSinsoft}
            style={{ width: "(8vw)", minWidth: "65px" }}
            alt="Logo Sinsoft Informática"
          />
        }
      />
      <ModalLoader loading={loadig} />
    </Container>
  );
}
